module.exports = __webpack_public_path__ + "static/media/brand-loader.325566c0.gif";